import React, { Component } from "react";
import LogoImage from "../../images/logo-default-light-200x36.png"

class FooterComponent extends Component {
    render() { 
        return (    <footer className="page-footer page-footer-default" id="footersection">
        <div className="shell">
          <div className="range range-xs-center">
            <div className="cell-lg-10"><a className="brand" href="/"><img src={LogoImage}
                  alt="" width="150" /></a>
              <div className="text-highlighted-wrap">
                <p className="text-highlighted">Hvala na ukazanom poverenju</p>
              </div>
              <ul className="footer-navigation footer-navigation-horizontal">
                <li><a href="/#mainsection">POČETAK</a></li>
                <li><a href="/#onama">O NAMA</a></li>
                <li><a href="/#usluge">USLUGE</a></li>
                <li><a href="/#lokacija">KONTAKT</a></li>
              </ul>
              <div className="divider divider-small divider-light block-centered"></div>
              <ul className="inline-list inline-list-md">
                <li><a className="icon icon-xs link-gray-light fa-facebook" href="https://www.facebook.com/ateljestojcic"></a>
                </li>
                <li><a className="icon icon-xs link-gray-light fa-instagram"
                    href="https://www.instagram.com/ateljestojcic/"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>);
    }
}
 
export default FooterComponent;